module.exports = __webpack_public_path__ + "img/开启同捆.6a05ffcf.svg";